module.exports = __webpack_public_path__ + "img/koi_nmg_xxlogo.005fad28.png";